import {Component, OnInit, AfterViewInit} from '@angular/core';
import { Grabaciones } from '../intefaces/grabaciones.interface';
import {Observable} from "rxjs";
import {CoursesService} from "../services/courses.service";
import {map} from "rxjs/operators";
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
    beginnerCourses$: Observable<Grabaciones[]>;
    sessionExpired: boolean = false;
    inactivityTimeout: boolean = false;
    sessionExpiredMessage: string = '';
    constructor(
        private coursesService: CoursesService,
        private route: ActivatedRoute
    ) {}
    
    ngOnInit() {
        const grabacion$ = this.coursesService.findAllCourses();
        this.beginnerCourses$ = grabacion$.pipe(
            map(grabacion => grabacion.filter(grab => grab.category === 'BEGINNER'))
        );
        
        // Verificar parámetros de sesión expirada
        this.route.queryParams.subscribe(params => {
            this.sessionExpired = params['sessionExpired'] === 'true';
            this.inactivityTimeout = params['inactivity'] === 'true';
            
            if (this.sessionExpired) {
                this.sessionExpiredMessage = this.inactivityTimeout 
                    ? 'Su sesión fue cerrada debido a inactividad.'
                    : 'Su sesión ha expirado. Por favor, inicie sesión nuevamente.';
            }
        });
    }
    
    ngAfterViewInit() {
        const grabacionA$ = this.coursesService.findAllCourses();
        this.beginnerCourses$ = grabacionA$.pipe(
            map(grabacion => grabacion.filter(grab => grab.category === 'BEGINNER'))
        );
    }
    
    close() {
        // Note: This method appears to be calling itself, which would cause infinite recursion
        // You may want to fix this if it's a mistake
    }
}